import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AvVi00Component } from './controllers/av-vi00/av-vi00.component';
import { AvVi01 } from './controllers/av-vi01.component';
import { AvVi02 } from './controllers/av-vi02.component';
import { HomeComponent } from './home.component';
import { PublicComponent } from './public/public.component';
import { AppAuthGuard } from './security/app-auth-guard';
import { SsvmnComponent } from './ssvmn.component';
import { AuthRoutingModule } from './auth/auth.routing';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'public', component: PublicComponent, children: [
      { path: 'presolicitud', component: AvVi00Component },
      { path: 'ingreso-presolicitud', component: AvVi01 },
      { path: 'consulta-presolicitud', component: AvVi02 }
    ]
  },

  {
    path: 'home', component: HomeComponent,
    canActivate: [AppAuthGuard],
    children: [
      { path: '', redirectTo: 'view/AV_VI05', pathMatch: 'full' },
      { path: 'view/:view-code', component: SsvmnComponent, children: [], pathMatch: 'full' },
      { path: 'view/:view-code/:child-view-code', component: SsvmnComponent, children: [], pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule, AuthRoutingModule]
})
export class AppRoutingModule { }
